import React, { useContext, useState, useEffect } from 'react';

import { Container } from './styles';
import MetaHeader from '../../components/MetaHeader';
import Loading from '../../components/atoms/Loading';
import Profiles from './Profiles';

export default function AccountSettings() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(async () => {
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Container>
      <MetaHeader
        title="Configurando sua conta na mLabs | Gestão de redes sociais"
        description="mLabs - Gestão de Redes Sociais | Configuração de conta"
      />
      {!isLoading && <Profiles />}
    </Container>
  );
}
